// "use client";
// import React, { useState } from "react";
// import VariableCheckbox from "./VariableCheckbox";

// // or from shadcn/ui

// type VariableItem = {
//   label: string;
//   value: string;
// };

// type Props = {
//   onSelect: (value: string) => void;
//   variables?: VariableItem[];
// };

// const defaultVariables: VariableItem[] = [
//   { label: "AWB Number", value: "(#AWB Number of shipments)" },
//   { label: "shipper_reference", value: "(#shipper_reference)" },
//   { label: "scheduled_reference", value: "(#scheduled_reference)" },
//   { label: "sender_name", value: "(#sender_name)" },
//   { label: "AWB Number 2", value: "(#AWB Number 2)" },
//   { label: "AWB Number 3", value: "(#AWB Number 3)" },
// ];

// const VariableDropdown = ({
//   onSelect,
//   variables = defaultVariables,
// }: Props) => {
//   const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

//   const handleSelect = (value: string, index: number) => {
//     setSelectedIndex(index);
//     onSelect(value);
//   };

//   return (
//     <div className="absolute mt-2 max-h-[200px] overflow-y-auto w-full z-50 bg-white border border-[#D8D8D8] rounded-xl [box-shadow:0px_2px_20px_0px_#00000040]">
//       {variables.map((item, idx) => (
//         <div
//           key={idx}
//           className="flex items-center justify-between px-4 py-2 border-b border-[#D2D2D2] hover:bg-gray-100 cursor-pointer"
//           onClick={() => handleSelect(item.value, idx)}
//         >
//           <div className="flex gap-2 items-center">
//             <span className="p-1 text-xs border border-[#D2D2D2] rounded-md bg-[#007BFF1A] text-[#007BFF]">
//               {item.label}
//             </span>
//             <span className="text-sm text-gray-600">{item.value}</span>
//           </div>
//           <VariableCheckbox checked={selectedIndex === idx} />
//         </div>
//       ))}
//     </div>
//   );
// };

// export default VariableDropdown;


"use client";
import { useState } from "react";

type VariableItem = {
  key: string;
  placeholder: string;
  description?: string;
};

type Props = {
  variables: VariableItem[];
  onSelect: (placeholder: string) => void;
};

const VariableDropdown = ({ variables, onSelect }: Props) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  return (
    <div className="absolute mt-2 max-h-[220px] overflow-y-auto w-full z-50 bg-white border rounded-xl shadow-lg">
      {variables.map((item, idx) => (
        <div
          key={idx}
          onClick={() => {
            setSelectedIndex(idx);
            onSelect(item.placeholder); 
          }}
          className="flex justify-between px-4 py-2 border-b cursor-pointer hover:bg-gray-100"
        >
          <div className="flex gap-2 items-center">
            <span className="p-1 text-xs border rounded-md bg-[#007BFF1A] text-[#007BFF]">
              {item.key}
            </span>
            <span className="text-sm text-gray-600">
              {item.description}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VariableDropdown;
